// DB module format
export interface ContentControlModule {
  webAccess: ContentControlWebAccessSection;
  webCategoriesFilter: ContentControlWebCategoriesFilterSection;
  antiphishing: ContentControlAntiphishingSection;
  application: ContentControlApplicationSection;
  dataProtection: ContentControlDataProtectionSection;
  traffic: ContentControlTrafficSection;
  networkMonitor: ContentControlNetworkMonitorSection;
}

// traffic section
export interface ContentControlTrafficSection {
  enable: boolean;
  enableExclusions: boolean;
  exclusions?: ContentControlTrafficExclusion[];
  trafficScan: ContentControlTrafficScan;
}

export interface ContentControlTrafficScanIncomingEmails {
  pop3: boolean;
  imap: boolean;
}

export interface ContentControlTrafficScanOutgoingEmails {
  smtp: boolean;
}

export interface ContentControlTrafficScanIncomingAndOutgoingEmails {
  mapi: boolean;
}

export interface ContentControlTrafficScan {
  incomingEmails: ContentControlTrafficScanIncomingEmails;
  outgoingEmails: ContentControlTrafficScanOutgoingEmails;
  incomingAndOutgoingEmails: ContentControlTrafficScanIncomingAndOutgoingEmails;
  webTraffic: boolean;
  emailTraffic: boolean;
}

export interface ContentControlTrafficExclusion {
  type: ContentControlTrafficExclusionType;
  entity: string;
  remarks: string;
}

export enum ContentControlTrafficExclusionType {
  IP = 1,
  URL = 2,
  APPLICATION = 3,
}

// antiphishing section
export interface ContentControlAntiphishingSection {
  enable: boolean;
  defaultAction: ContentControlAntiphishingDefaultAction;
  settings: {
    protectionAgainstFraud: boolean;
    protectionAgainstPhishing: boolean;
  };
}

export enum ContentControlAntiphishingDefaultAction {
  BLOCK = 1,
  REPORT_ONLY = 2,
}

// network monitor section
export interface ContentControlNetworkMonitorSection {
  enable: boolean;
  inspectRdpTraffic: boolean;
  attackTechniques: ContentControlNetworkMonitorAttackTechnique[];
  serverTrafficScan: ContentControlNetworkMonitorServerTrafficScan
}

export interface ContentControlNetworkMonitorServerTrafficScan {
  enabled: boolean,
  inspectEncryptedDomainControllerTraffic: boolean,
}

export interface ContentControlNetworkMonitorAttackTechnique {
  enable: boolean;
  name: ContentControlNetworkMonitorAttackTechniqueName;
  action: ContentControlNetworkMonitorAttackTechniqueAction;
}

export enum ContentControlNetworkMonitorAttackTechniqueName {
  INITIAL_ACCESS = 1,
  CREDENTIAL_ACCESS = 2,
  LATERAL_MOVEMENT = 3,
  CRIMEWARE = 4,
  DISCOVERY = 5,
}

export enum ContentControlNetworkMonitorAttackTechniqueAction {
  REPORT_ONLY = 0,
  BLOCK_PROCESS = 3,
}

// web access section
export interface ContentControlWebAccessSection {
  enable: boolean;
  profileType: number;
  useExceptions: boolean;
  scheduler: ContentControlWebAccessScheduler[];
  webRules: ContentControlWebAccessRule[];
}

export interface ContentControlWebAccessScheduler {
  day: number;
  intervals: ContentControlWebAccessSchedulerInterval[];
}

export interface ContentControlWebAccessSchedulerInterval {
  start: number;
  end: number;
}

export interface ContentControlWebAccessRule {
  webAddress: string;
  permission: ContentControlWebAccessRulePermission;
}

export enum ContentControlWebAccessRulePermission {
  BLOCK = 1,
  ALLOW = 2,
}

// web categories filter section
export interface ContentControlWebCategoriesFilterSection {
  profileType: number;
  scheduleId: string | null;
}

// application section
export interface ContentControlApplicationSection {
  enable: boolean;
  rules: ContentControlApplicationRule[];
}

export interface ContentControlApplicationRule {
  appPath: string;
  permission: ContentControlApplicationRulePermission;
  scheduler: ContentControlWebAccessScheduler[];
}

export enum ContentControlApplicationRulePermission {
  BLOCK = 1,
  SCHEDULED = 2,
  ALLOW = 3,
}

// data protection section
export interface ContentControlDataProtectionSection {
  enable: boolean;
  rules: ContentControlDataProtectionRule[];
  exclusions: ContentControlDataProtectionExclusion[];
}

export interface ContentControlDataProtectionRule {
  name: string;
  type: ContentControlDataProtectionRuleType;
  string: string;
  scanWebTraffic: boolean;
  scanEmailTrafiic: boolean;
  matchWholeWords: boolean;
  matchCase: boolean;
}

export enum ContentControlDataProtectionRuleType {
  ADDRESS = 1,
  BANKACCNO = 2,
  CCNO = 3,
  EMAIL = 4,
  NAME = 5,
  PASSWORD = 6,
  PIN = 7,
  SSN = 8,
  PHONE = 9,
}

export interface ContentControlDataProtectionExclusion {
  address: string;
  rulesToConsider: ContentControlDataProtectionExclusionRule[];
  type: ContentControlDataProtectionExclusionType;
}

export interface ContentControlDataProtectionExclusionRule {
  ruleName: string;
}

export enum ContentControlDataProtectionExclusionType {
  WEB = 1,
  EMAIL = 2,
}
